import React from 'react'

export default function FilterIcon(props) {
    const { width = 32, height = 32, color = '#418379' } = props
    return (
        <svg t="1746604959231" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6178" width={width} height={height}>
            <path d="M608.256 960c-17.696 0-32-14.304-32-32V448a31.912 31.912 0 0 1 8.256-21.44l208.8-234.496h-562.88L439.648 426.72a32.03 32.03 0 0 1 8.096 21.312V736.8l50.848 41.152c13.76 11.136 15.872 31.264 4.736 44.992s-31.264 15.84-44.992 4.736l-62.72-50.752c-7.52-6.048-11.872-15.232-11.872-24.864V460.192L135.136 181.344c-8.384-9.408-10.464-22.88-5.312-34.4 5.152-11.488 16.608-18.912 29.216-18.912h706.336c12.672 0 24.128 7.456 29.248 19.008s2.976 25.056-5.504 34.432L640.256 460.288V928c0 17.696-14.304 32-32 32z" p-id="6179" fill={color}></path>
        </svg>
    )
}
